module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-side",
    style: ({
      'overflow-y': _vm.leftSideOpen ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "left-side-inner"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked custom-nav left-menus"
  }, _vm._l((_vm.menus), function(item, index) {
    return _c('li', {
      staticClass: "menu-list",
      class: {
        'open': item.indexPath === _vm.currentActiveMenuPath, 'nav-hover': _vm.hoverIndex == index
      },
      on: {
        "mouseenter": function($event) {
          return _vm.itemHover($event, index)
        },
        "mouseleave": function($event) {
          return _vm.itemHover($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "submenu-title menu-title",
      on: {
        "click": function($event) {
          return _vm.toggleclick($event, item)
        }
      }
    }, [_c('span', [_c('i', {
      class: item.tree.icon
    }), _c('span', [_vm._v(_vm._s(item.label))])])]), _vm._v(" "), (item.children && item.children.length > 0) ? [_c('ul', {
      staticClass: "sub-menu-list",
      attrs: {
        "transition": "expand"
      }
    }, _vm._l((item.children), function(child, childIndex) {
      return _c('li', {
        staticClass: "sub-menu-item",
        class: {
          'active': child.indexPath === _vm.currentActivePath
        }
      }, [_c('router-link', {
        attrs: {
          "to": item.tree.url + '/' + child.tree.url
        }
      }, [_c('div', {
        staticClass: "submenu-title",
        on: {
          "click": function($event) {
            return _vm.itemclick($event, item, child)
          }
        }
      }, [_c('span', [_c('i', {
        class: child.tree.icon
      }), _vm._v(_vm._s(child.label) + "\n                                        ")])])])], 1)
    }), 0)] : _vm._e()], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "left-side-bottom"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "value": true,
      "content": "点击查看版本更新内容",
      "placement": "top"
    }
  }, [_c('p', {
    on: {
      "click": _vm.showTip
    }
  }, [_vm._v("系统版本" + _vm._s(_vm.currentVersion) + "(" + _vm._s(_vm.currentUpdateTime) + ")")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0dbfeac8!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/navmenu.vue
// module id = 1075
// module chunks = 99